import Image from 'next/image'

import { ImageWithPlaceholder } from '@components/ImageWithPlaceholder'
import { AppRoutes } from '@constants/app-routes'
import { PartnershipRoutes } from '@constants/partnership-routes'
import { useMediaQuery } from '@hooks/use-media-query'
import { NormalizedWrapper } from '@theme'

import { config } from './config'
import {
  Wrapper,
  Copyright,
  SocialList,
  SocialListItem,
  FooterLink,
  BlocksGroupWrapper,
  Title,
  CopyrightWrapper,
  Privacy,
  BlockWrapper,
  OrangeLink,
  ListText,
  SocListAndTextWrapper,
  LogoWrapper,
  ContactUsBlock,
} from './styles'

const {
  groups,
  links,
  mailLink,
  phoneLink,
  copyrightText,
  privacyText,
  microsoftLogo,
} = config

export function Footer() {
  const isLaptop = useMediaQuery(`(min-width: ${1441}px)`)

  const handleClick = () => {
    window.open(PartnershipRoutes.microsoft, '_blank')
  }

  const socialLinks = (
    <SocialList>
      {links.map(({ id, path, label, imagePath, imageWidth, imageHeight }) => (
        <SocialListItem key={id}>
          <FooterLink href={path} title={label} target="_blank" rel="noopener">
            <ImageWithPlaceholder
              src={imagePath}
              alt={label}
              width={imageWidth}
              height={imageHeight}
            />
          </FooterLink>
        </SocialListItem>
      ))}
    </SocialList>
  )

  return (
    <NormalizedWrapper>
      <Wrapper>
        <BlocksGroupWrapper>
          {groups.map(({ title, links: groupLinks }) => (
            <BlockWrapper key={title}>
              <Title>{title}</Title>
              {groupLinks.map(({ label, path }) => (
                <FooterLink key={path} href={path} title={label}>
                  {label}
                </FooterLink>
              ))}
            </BlockWrapper>
          ))}
          <ContactUsBlock>
            <SocListAndTextWrapper>
              <Title>Contact Us:</Title>
              {isLaptop && socialLinks}
            </SocListAndTextWrapper>
            <ListText>
              <OrangeLink href={mailLink.path}>{mailLink.label}</OrangeLink>
            </ListText>
            <ListText>
              Phone:{' '}
              <OrangeLink href={phoneLink.path}>{phoneLink.label}</OrangeLink>
            </ListText>
            <ListText>Stefana Okrzei 1a/10{'\n'}Warsaw, Poland</ListText>
            {!isLaptop && socialLinks}
          </ContactUsBlock>
        </BlocksGroupWrapper>
        <CopyrightWrapper>
          <LogoWrapper onClick={handleClick}>
            <Image
              src={microsoftLogo.src}
              alt={microsoftLogo.alt}
              width={microsoftLogo.width}
              height={microsoftLogo.height}
            />
          </LogoWrapper>
          <Copyright>{copyrightText}</Copyright>
          <Privacy href={AppRoutes.privacyPolicy}>{privacyText}</Privacy>
        </CopyrightWrapper>
      </Wrapper>
    </NormalizedWrapper>
  )
}
